/**
 * 服务器配置相关常量，约定常量使用大写，
 * 如果是GeoServer图层，以GEOSERVER为前缀，使用source-layer作为主体
 */

const concatSlash = str => {
  if (!str) return '/';
  if (str[str.length - 1] !== '/') {
    return `${str}/`;
  }
  return str;
};

// 基地址，总以/进行结尾
const { REACT_APP_BASE_URL, REACT_APP_ENV_PREFIX } = process.env;
const BASE_URL = `${concatSlash(REACT_APP_BASE_URL)}${REACT_APP_ENV_PREFIX}`;
// 基础服务器
const API = `${BASE_URL}livingRoomTaiAn`;
// 静态地理数据
const GEO_STATIC = process.env.REACT_APP_JSON_URL;
// 验证码路径，key为参数
const CAPTCHA = `${BASE_URL}oauth/captcha`;
const OAUTH_SERVER = `${BASE_URL}oauth`;
const UPMS_SERVER = `${BASE_URL}upms`;

/**
 * 服务器配置相关常量
 */
const SERVER_CONFIG = {
  BASE_URL: BASE_URL ?? '/',
  API,
  GEO_STATIC,
  CAPTCHA,
  OAUTH_SERVER,
  UPMS_SERVER,
};

export default SERVER_CONFIG;
